import rp from "./global";
import type { SettingsItem } from "./types";
import { EDITOR_SETTINGS_SPECS } from "./editors/editorSettings";

export const CORE_SETTINGS_SPECS: SettingsItem[] = [{
	id: 'theme',
	description: 'Application UI Theme',
	type: 's',
	content: () => [...rp.theme.manager.themes.keys()].map(t => ({k: t, v: t}))
}, {
	id: 'title.format',
	description: 'Format of the application title in the browser tab',
	type: 't',
	defaultValue: '{company_name} - {service_name}'
}, {
	id: 'host.alerts.position',
	description: 'Where the notifications (alerts) appear in the window',
	type: 's',
	defaultValue: 'top-center',
	content: [
		{k: 'top-left', v: 'top left'},
		{k: 'top-center', v: 'top center'},
		{k: 'top-right', v: 'top right'},
		{k: 'bottom-left', v: 'bottom left'},
		{k: 'bottom-center', v: 'bottom center'},
		{k: 'bottom-right', v: 'bottom right'},
	],
}, {
	id: 'host.home.id_context',
	description: 'Homepage saved view ID',
	type: 'n',
	defaultValue: null
}, {
	id: 'host.home.auto_open',
	description: 'Automatically open homepage after login',
	type: 'b',
	defaultValue: null
}, {
	id: 'etl.threads.sorting',
	description: 'ETL thread tree sorting',
	type: 's',
	defaultValue: 'description/ord_num',
	content: [
		{k: 'description', v: 'name'},
		{k: 'ord_num', v: 'order number'},
		{k: 'description/ord_num', v: 'name/order number'},
	],
}, {
	id: 'accounting.search.sorting',
	description: 'Order of the companies in the company switcher (the match ranking applies to a typed term, without one the list goes by name)',
	type: 's',
	defaultValue: 'match',
	content: [
		{k: 'match', v: 'best match first'},
		{k: 'name', v: 'group and company name'},
		{k: 'id', v: 'group and company ID'},
	],
}, {
	id: 'result.tab.color',
	description: 'Color of the SQL result tab (HEX without #). Set to 0 for no color.',
	type: 't',
	defaultValue: '503085',
}, {
	id: 'analytics.finance.columns',
	description: 'Column settings for the finance transaction detail ({column: string, hidden?: boolean}[])',
	type: 't',
	defaultValue: null,
	hidden: true,
}, {
	id: 'analytics.items.columns',
	description: 'Column settings for the items transaction detail ({column: string, hidden?: boolean}[])',
	type: 't',
	defaultValue: null,
	hidden: true,
}, {
	id: 'analytics.aging.columns',
	description: 'Column settings for the aging transaction detail ({column: string, hidden?: boolean}[])',
	type: 't',
	defaultValue: null,
	hidden: true,
}, {
	id: 'ai.api.standard',
	description: 'AI API standard to use for the AI module',
	type: 's',
	defaultValue: 'anthropic', // sync with AIConfigService::DEFAULT_STANDARD
	content: [
		{k: 'anthropic', v: 'Anthropic Messages API'},
		{k: 'openai', v: 'OpenAI-Compatible API'},
		{k: 'google', v: 'Google Gemini API'},
	],
}, {
	id: 'ai.api.url',
	description: 'API URL for the AI module',
	type: 't',
	defaultValue: 'https://api.anthropic.com/v1', // sync with AIConfigService::DEFAULT_URL
}, {
	id: 'ai.api.key',
	secure: true,
	description: 'API key for the AI module',
	type: 't',
	defaultValue: null,
}, {
	id: 'ai.models',
	description: 'AI models to use for the AI module separated by comma (e.g. "gpt-4,gpt-3.5")',
	type: 't',
	defaultValue: 'claude-fable-5-1,claude-opus-5-5,claude-sonnet-5-5,claude-haiku-5-5', // sync with AIConfigService::DEFAULT_MODELS
}, {
	id: 'ai.chat.settings',
	description: 'Last state of the AI chat ({includeData: boolean, includeDefinition: boolean, includeGroup: boolean, enableThinking: boolean, model: string}).',
	type: 't',
	defaultValue: { includeData: false, includeDefinition: false, includeGroup: false, enableThinking: true }, // sync with AIConfigService::DEFAULT_TOGGLES
	hidden: true,
},
// the code editors (see editors/editorSettings.ts): completion, Monaco look; the SQL ones are hidden in the grid
...EDITOR_SETTINGS_SPECS,
];
